module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "wrapper",
    staticClass: "list"
  }, [_c('PullReload', {
    attrs: {
      "onReload": _vm.onReload
    }
  }, [_c('div', {
    staticStyle: {
      "height": "20px"
    }
  }), _vm._v(" "), _vm._l((_vm.list), function(item) {
    return _c('ArticleListItem', {
      attrs: {
        "item": item
      }
    })
  }), _vm._v(" "), (_vm.loading && !_vm.pullLoading) ? _c('div', {
    staticClass: "loading"
  }, [_vm._v("正在加载...")]) : _vm._e(), _vm._v(" "), (!_vm.loading && _vm.list.length && !_vm.inTheEnd) ? _c('div', {
    staticClass: "more",
    on: {
      "click": function($event) {
        _vm.loadMore();
      }
    }
  }, [_vm._v("更多...")]) : _vm._e(), _vm._v(" "), (!_vm.loading && _vm.list.length && _vm.inTheEnd) ? _c('div', {
    staticClass: "more"
  }, [_vm._v("- 没有更多啦 -")]) : _vm._e(), _vm._v(" "), (!_vm.loading && !_vm.list.length) ? _c('div', {
    staticClass: "no-more"
  }, [_vm._v(" Oh-oh! 这里还没有数据哦 "), _c('br'), _vm._v(" 快去发布吧")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "iphone-x-block"
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "80px"
    }
  })], 2), _vm._v(" "), _c('BottomBar')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5b86814e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/article-list.vue
// module id = 236
// module chunks = 1